import { combineReducers } from '@reduxjs/toolkit'
import controllerReducer from '../../utils/controller/reducer/controller'
import user from './user'
import requests from './requests'
import content from './content'
import modalsData from './modalsData'
import elf from './elf'
import errorHandlerReducer from './errorHandlerReducer'
import requestsHandler from './requestsHandler'
import service from './service'

const rootReducer = combineReducers({
  controllerReducer,
  [requests.name]: requests.reducer,
  [user.name]: user.reducer,
  [content.name]: content.reducer,
  [modalsData.name]: modalsData.reducer,
  [elf.name]: elf.reducer,
  [errorHandlerReducer.name]: errorHandlerReducer.reducer,
  [requestsHandler.name]: requestsHandler.reducer,
  [service.name]: service.reducer,
})

export default rootReducer
